import React, { useEffect, useState } from 'react';
import renderHTML from 'react-render-html';
import API, { graphqlOperation } from '@aws-amplify/api';
import withStyles from '@material-ui/core/styles/withStyles';
import { Card, CardContent} from '@material-ui/core';

import { styles } from './styles';
import withRoot from '../../withRoot';
import { GetRoraySite } from '../../graphql/queries'; 
import awsmobile from '../../aws-exports'; 
 
API.configure(awsmobile); 

interface IBillsProps {
  classes: any;
  client: any;
}

const Bills: React.FC<IBillsProps> = ({ classes, client }) => {
  const [pageData, setPageData] = useState(); 

  useEffect(() => { 
    getHTMLData();
  }); 
  
  const getHTMLData = async () => { 
    const helpData: any = await API.graphql(graphqlOperation(GetRoraySite, {
      "siteId": process.env.REACT_APP_GLOBAL_SITEID,
      "typeValue": "pages::honeycode-glossary-chat-home"
    })); 
    let content = helpData.data.getRoraySiteN4udipg3snevddjjskvzzepdhaJcdev.content; 
    let temp = htmlDecode(content); 
    if (content !== null) { 
      setPageData(temp); 
    } 
  }

  const htmlDecode = (input: any) => { 
    var e = document.createElement("textarea"); 
    e.innerHTML = input;
    return e.value; 
  };

  return (
    <>
  <Card className={classes.card}>
      <CardContent>
      {pageData && renderHTML(pageData)} 
        </CardContent>
      </Card>
      <br />
      <br />
      <br />
    </>
  );
};

export default withRoot(withStyles(styles)(Bills));
